<ntw-grid-template gridTitle="order.title" [totalValues]="this.totalValues" graphTitle="order.graph.title"
    [currentAccount]="this.currentAccount" [columnSettings]="this.columnSettings" idFieldName="Id"
    [entities]="this.entities" [dataGridView]="this.dataGridView" [summaries]="this.summaries" [loading]="this.loading"
    [dataStateChange]="this.dataStateChange"
    [generateSummary]="this.generateSummary" [kendoGridState]="this.kendoGridState"
    (afterValueChanged)="this.onAfterValueChanged($event)" [showButtonsColumn]="true" [showOpenButton]="true" openButtonIcon="eye">
</ntw-grid-template>